import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import Quagga from 'quagga';

import { deviceDetect } from 'react-device-detect';

import { history } from '../../../store';

import { CUSTOMER_CREATE_URL } from '../../../constants/api';

import isLoggedIn, {isGM, isSA, getUserObj} from '../../../utils/auth';

import RhinoModal from '../../common/modal/RhinoModal';

import {HeaderMenuContainer} from './HeaderMenu';
import {HeaderRightMenuContainer} from './HeaderRightMenu';
import {HeaderCalculatorContainer} from './HeaderCalculator';
import {NewMessageContainer} from '../messages/NewMessage';
import {SendLeadDropdownContainer} from '../leads/SendLeadDropdown';
import {AddToCardContainer} from '../leads/AddToCard';
import {ShareDirectContainer} from '../leads/ShareDirect';

import * as commonActionCreators from '../../../actions/common';
import * as headerActionCreators from '../../../actions/header';
import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, commonActionCreators, headerActionCreators, messagesActionCreators, usersActionCreators);


class Header extends React.Component {

	constructor(props) {

		super(props);

		this.scanningElementId = 'scanning-element-jewelry-search-header-id';

		this.state = {
			heartbeat: Date.now(),
			messageSeconds: 60,
			messageCount: 0,

			showAddIcon: window.location.href.includes('/leads'),

			calcOpen: false,

			scanningModelOpen: false,
			scanningError: null,
			scanningAutomatedMode: null,

			manualSku: '',
		};

		this.intId = null;

		this.scanningElement = null;
		this.scanningElementRef = React.createRef();

		// Bind event listener method
		this.beatHeart = this.beatHeart.bind(this);

		this.scanSuccessMtd = this.scanSuccess.bind(this);
		this.scanErrorMtd = this.scanError.bind(this);
	}

	componentDidMount() {
		this.intId = setInterval(this.beatHeart, 10000);
		this.fetchUserData();
	}

	componentDidUpdate(prevProps, prevState) {
		if(window.location.href.includes('/leads') !== this.state.showAddIcon) {
			this.setState({
				showAddIcon: !this.state.showAddIcon,
			});
		}
	}

	componentWillUnmount() {
		if(this.intId) {
			clearInterval(this.intId);
		}
	}

	async initiateScanner() {

		if(this.scanningElementRef && this.scanningElementRef.current) {

			// Pick the right camera
			const constraints = {
				audio: false,
				video: {
					facingMode: 'environment',
					width: { ideal: 4096 },
					height: { ideal: 2160 },
				}
			}

			const cams = await navigator.mediaDevices.getUserMedia(constraints);

			const allCams = cams.getVideoTracks();

			let camId = '';
			let camMaxWidth = 0;

			for(const trk of allCams) {
				
				const capabilities = trk.getCapabilities();
				const settings = trk.getSettings();

				if(capabilities.width.max > camMaxWidth) {
					camId = settings.deviceId;
					camMaxWidth = capabilities.width.max;
				}
			}

			const qConstraints = camId ? { deviceId: camId } : { facingMode: 'environment' };

			Quagga.onDetected(this.scanSuccessMtd);

			Quagga.init({
				locate: true,
				frequency: 10,
				inputStream: {
					name : "Live",
					type : "LiveStream",
					target: document.querySelector(`#${this.scanningElementId}`),
					constraints: qConstraints,
				},
				decoder : {
					readers : ["code_128_reader"],
					multiple: false,
				},
				locator: {
					halfSample: false,
					patchSize: "small",
				},
				debug: false,
			}, function(err) {
				if (err) {
					console.error(err);
					return
				}
				Quagga.start();
			});
		}
	}

	terminateScanner() {
		try {
			Quagga.offDetected(this.scanSuccessMtd);
			Quagga.stop();
		} catch(err) {
			console.error(err);
		}
	}

	scanSuccess(data) {

		// this.userNav(`jewelry/view/MTGPL04404`);
		this.userNav(`jewelry/barcode/${data.codeResult.code}`);

		this.closeScanningModal();
	}

	scanError(err) {
		console.error(err);
	}

	closeScanningModal() {
		this.setState({ scanningModelOpen: false }, () => {
			this.terminateScanner();
		});
  }

	defaultToAutomated() {
		try {
		
			// const minIos = 16;
			// const minAndroid = 13;

			// const deviceObj = deviceDetect();

			// const versionInt = parseInt(deviceObj.osVersion.split('.')[0]);

			// if(deviceObj.os === 'iOS' && versionInt >= minIos) {
			//   return true;
			// } else if(deviceObj.os === 'Android' && versionInt >= minAndroid) {
			//   return true;
			// }
			return false;

		} catch(err) {
			return false;
		}
	}

	setInputToAutomated(isAutomated) {
		this.setState({
			scanningAutomatedMode: isAutomated,
		}, () => {
			if(isAutomated) {
				this.initiateScanner();
			} else {
				this.terminateScanner();
			}
		});
	}

	openScanningModal() {
		this.setState({ scanningModelOpen: true }, () => {
			this.setInputToAutomated(this.state.scanningAutomatedMode === null ? this.defaultToAutomated() : this.state.scanningAutomatedMode);
		});
	}

	beatHeart() {
		this.setState({
			heartbeat: Date.now(),
			messageCount: this.state.messageCount >= this.state.messageSeconds ? 0 : this.state.messageCount + 1,
		}, () => {
			this.fetchUserData();
		});
	}

	fetchUserData() {

		if(isLoggedIn() === true) {

			// Fetch user messages 
			if(this.state.messageCount === 0) {
				this.props.fetchUserMessages()
					.then((respData) => {
						this.props.messagesSave(respData.messages);
					})
			}

			// Fetch deleted messages
			if(this.state.messageCount === 0) {
				this.props.fetchDeletedUserMessages()
					.then((respData) => {
						this.props.messagesDeletedSave(respData.messages);
					})
			}

			// Fetch user directory
			if(this.props.messages.directory === null) {
				this.props.fetchUserDirectory()
					.then((respData) => {
						this.props.messagesSaveDirectory(respData.users);
					})
			}
		}
	}

	userNav(page) {
		history.push('/' + page);
	}

	diamondNav() {
		history.push('/diamonds');
	}

	customerCardNav() {
		let win = window.open(CUSTOMER_CREATE_URL, '_blank');
		win.focus();
	}

	getHeaderHideStyles() {
		return window.location.pathname === '/' ? {display: 'none'} : {};
	}

	openCalc() {
		this.setState({
			calcOpen: true,
		});
	}

	closeCalc() {
		this.setState({
			calcOpen: false,
		});
	}

	getUserName() {
		if(isLoggedIn()) {
			const userObj = getUserObj();
			if(userObj) {
				return `${userObj.first_name} ${userObj.last_name}`;
			}
		}
		return '';
	}

	changeManualSku(evt) {
		this.setState({ manualSku: evt.target.value });
	}

	submitManualSearch() {
		if(this.state.manualSku) {
			this.userNav(`jewelry/view/${this.state.manualSku}`);
		}
  	}

	render() {
		return <div className='Header' style={this.getHeaderHideStyles()}>
			<div className='headerElement'>
				<div className='headerIcon' onClick={this.diamondNav.bind(this)}>
					<div className='iconWrapper'>
						<img src='/img/header/icon.svg' />
					</div>
				</div>
				<div className='headerLeftMenu'>
					<HeaderMenuContainer />
				</div>
				<div className='headerStatus'>
					<div className='statusLabel'>{isLoggedIn() ? 'Logged in as:' : 'Not logged in'}</div>
					{isLoggedIn() ?
						<div className='statusValue'>{this.getUserName()}</div> :
						null
					}
				</div>
				{isLoggedIn() === true ?
					<div 
						className={'headerCalcIcon barcodeIcon'}
						style={isLoggedIn() && !this.state.showAddIcon ? { display: 'block' } : { display: 'none' }}
						onClick={this.openScanningModal.bind(this)}>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"/></svg>
					</div> :
					null
				}
				{isLoggedIn() === true ?
					<div 
						className={isLoggedIn() && this.state.showAddIcon ? 'headerCalcIcon' : 'headerCalcIcon rightmost'}
						onClick={this.openCalc.bind(this)}>
						<img src='/img/header/calc.svg' />
					</div> :
					null
				}
				{isLoggedIn() && this.state.showAddIcon ?
					<div className='headerRightIcon'>
						<img src='/img/header/addcard.svg' />
					</div> :
					null
				}
				{this.state.showAddIcon ?
					<div className='headerRightMenu'>
					{isGM() || isSA() ?
						<HeaderRightMenuContainer /> :
						<div className='cardNavWrapper' onClick={this.customerCardNav.bind(this)}></div>
					}
					</div> :
					null
				}
				<div className='calcWrapper' style={this.state.calcOpen ? { display: 'block' } : { display: 'none ' }}>
					<HeaderCalculatorContainer
						closeCalc={this.closeCalc.bind(this)} />
				</div>
				<SendLeadDropdownContainer />
				<NewMessageContainer />
				<AddToCardContainer />
				<ShareDirectContainer />
				<RhinoModal
					open={this.state.scanningModelOpen}>

					<div className='scanningModal'>
						<div className='closeModal' onClick={this.closeScanningModal.bind(this)}>&times;</div>
						<div className='scanningModalTitle'>{this.state.scanningAutomatedMode ? 'Scan Barcode' : 'Enter SKU'}</div>
						<div className='scanningModalHr'>
							<img src='/img/icons/lines/iconline_thin.svg' alt='' />
						</div>
						{this.state.scanningError ? 
							<div className='errMessage'>{this.state.scanningError}</div> :
							null
						}
						<div className='scanningBody'>
							{this.state.scanningAutomatedMode ?
								<div className='scanningElementWrapper'>
									<div id={this.scanningElementId} ref={this.scanningElementRef} className='scanningElement'></div>
								</div> :
								<div className='manualEntryWrapper'>
									<form className='manualEntryForm' onSubmit={this.submitManualSearch.bind(this)}>
										<div className='mfInputWrapper'>
											<input
												className='mfInput'
												value={this.state.manualSku}
												onChange={this.changeManualSku.bind(this)}
												placeholder={'BR11001563'} />
										</div>
										<div className='mfSubmitWrapper'>
											<button type='submit' className='mfSubmitButton'>Submit</button>
										</div>
									</form>
								</div>
							}
							<div className='automationToggle'>
								<div 
									className='automationToggleLink' 
									onClick={() => this.setInputToAutomated(!this.state.scanningAutomatedMode)}
									style={this.state.scanningAutomatedMode ? { margin: '0' } : {}}>
									{this.state.scanningAutomatedMode ? 'Switch to manual entry' : 'Switch to automated scanning'}
								</div>
							</div>
							{this.state.scanningAutomatedMode ?
								<div className='scanCopyWrapper'>
									<div className='scanCopyTitle'>Scanning Tips</div>
									<ul className='scanTips'>
									<li>Automated scanning only available on newer devices (eg, iPhone 14 or greater).</li>
									<li>If propted to allow permissions for the device camera, click <strong>Allow/Yes</strong>.</li>
									<li>Hold the tablet with one hand and position the barcode within the camera viewfinder on the screen.</li>
									<li>Ensure that the barcode is well-lit and clearly visible to the camera.</li>
									<li>Align the barcode within the rectangular box displayed on the screen.</li>
									<li>The camera will automatically focus on the barcode. When a barcode has been successfully scanned, the jewelry page will automatically open.</li>
									</ul>
								</div> :
								null
							}
						</div>
					</div>
				</RhinoModal>
			</div>
			<div className='headerSpacer'></div>
		</div>
	}
}
export default Header;

function mapStateToProps(state) {
	return {
		auth: state.auth,
		header: state.header,
		messages: state.messages,
		users: state.users,
	};
}

export const HeaderContainer = connect(
	mapStateToProps,
	allActionCreators
)(Header);